import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';
import { MessageService } from 'src/app/services/message-service/message.service';
import { UserAddressService } from 'src/app/services/user-address/user-address.service';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
    selector: 'app-mm-user-address',
    templateUrl: './mm-user-address.component.html',
    styleUrls: ['./mm-user-address.component.scss'],
})
export class MmUserAddressComponent implements OnInit {

    public formAddress: any = {};
    public formRescue: FormGroup;
    listOfAddresses: any = [];

    addAddress: boolean = false;
    editAddress: boolean = false;

    @Output() toEventDismiss: EventEmitter<any> = new EventEmitter();

    constructor(private userAddressService: UserAddressService,
        private formBuilder: FormBuilder,
        private modelLocator: ModelLocatorService,
        public utilService: UtilService,
        private messageService: MessageService
    ) { }

    async ngOnInit() {
        this.formRescue = this.formBuilder.group({
            zipcode: [
                this.formAddress.zipcode,
                Validators.compose([
                    Validators.required,
                    Validators.minLength(8),
                    Validators.maxLength(9)
                ]),
            ],
            street: [
                this.formAddress.street,
                Validators.compose([
                    Validators.required
                ]),
            ],
            number: [
                this.formAddress.number,
                Validators.compose([
                    Validators.required,
                    Validators.minLength(1),
                    Validators.maxLength(15)
                ]),
            ],
            complement: [
                this.formAddress.complement,
                Validators.compose([
                    Validators.required
                ]),
            ],
            district: [
                this.formAddress.district,
                Validators.compose([
                    Validators.required
                ]),
            ],
            city: [
                this.formAddress.city,
                Validators.compose([
                    Validators.required
                ]),
            ],
            state: [
                this.formAddress.state,
                Validators.compose([
                    Validators.required,
                    Validators.minLength(2),
                    Validators.maxLength(2)
                ]),
            ],
            reference: [
                this.formAddress.reference,
                Validators.compose([
                    Validators.required,
                    Validators.minLength(1),
                    Validators.maxLength(20)
                ]),
            ],
        });
    }

    async ngAfterContentInit() {
        await this.getListOfAddres();
    }

    async getListOfAddres() {

        this.messageService.startLoading("Carregando...");
        await this.userAddressService.getListOfUserAddress().then((data: any) => {

            if (data['status'] == 200) {
                this.listOfAddresses = data.result.sort((a, b) => a.id - b.id);
                this.addAddress = this.listOfAddresses.length == 0 ? true : false;
            }

            this.messageService.endLoading();
        }).catch(error => {
            console.log("🚀 ~ MmUserAddressComponent ~ awaitthis.userAddressService.getListOfUserAddress ~ error:", error);
            this.messageService.endLoading();
        })

    }

    /**
     * Gets address by cep
     * @author Starley Cazorla
     * @returns
     */
    async getAddressByCep() {

        if (this.formAddress === undefined || this.formAddress.zipcode.length < 9) {
            return;
        }

        await this.utilService.getAddressByCep(this.formAddress.zipcode).then((data: any) => {
            if (data) {
                this.formAddress.street = data.logradouro;
                this.formAddress.district = data.bairro;
                this.formAddress.city = data.localidade;
                this.formAddress.state = data.uf;
            }
        }).catch(error => {
            console.log("🚀 ~ MmUserAddressComponent ~ getAddressByCep ~ error:", error);

            this.messageService.showToast(error['error'].message, 'warning', 'bottom', 5000, true);
        })
    }

    isValidForm(): boolean {
        if (!this.formRescue.valid) return false;
        return true;
    }

    touchSelectAddress(address: any) {
        this.formAddress = address.detail.value || {};
        if (this.formAddress) {
            this.formRescue.patchValue({
                zipcode: this.formAddress.zipcode,
                street: this.formAddress.street,
                number: this.formAddress.number,
                complement: this.formAddress.complement,
                district: this.formAddress.district,
                city: this.formAddress.city,
                state: this.formAddress.state,
                reference: this.formAddress.reference,
            });
        }
    }

    touchAddNewAddress() {
        this.formAddress = {};
        this.addAddress = true;
    }

    touchBackToList() {
        this.addAddress = false;
        this.editAddress = false;
    }

    /**
     * Touchs save address
     * @author Starley Cazorla
     */
    async touchSaveAddress() {
        this.messageService.startLoading("Salvando...");

        if (this.addAddress) {
            this.formAddress.cpf = this.modelLocator.dadosLogin.cpf;
            this.formAddress.status = true;
            this.formAddress.option = this.listOfAddresses.length == 0 ? "principal" : "secundario";
            this.formAddress.zipcode = this.formAddress.zipcode.replace(/[^0-9]/g, '');

            await this.userAddressService.saveUserAddress(this.formAddress).then((data: any) => {
                if (data['status'] == 200) {
                    this.getListOfAddres();
                    this.formRescue.reset();
                    this.addAddress = false;
                }
                this.messageService.endLoading();
            }).catch(error => {
                console.log("🚀 ~ MmUserAddressComponent ~ touchSaveAddress ~ error:", error);
                this.messageService.endLoading();
                this.messageService.showToast(error['error'].message, 'warning', 'bottom', 5000, true);
            });
        }

        if (this.editAddress) {
            this.formAddress.cpf = this.modelLocator.dadosLogin.cpf;
            this.formAddress.zipcode = this.formAddress.zipcode.replace(/[^0-9]/g, '');

            await this.userAddressService.updateUserAddress(this.formAddress).then((data: any) => {
                if (data['status'] == 200) {
                    this.getListOfAddres();
                    this.formRescue.reset();
                    this.editAddress = false;
                }
                this.messageService.endLoading();
            }).catch(error => {
                console.log("🚀 ~ MmUserAddressComponent ~ touchSaveAddress ~ error:", error);
                this.messageService.endLoading();
                this.messageService.showToast(error['error'].message, 'warning', 'bottom', 5000, true);
            });
        }

    }

    /**
     * Touchs delete address
     * @author Starley Cazorla
     * @param address
     */
    async touchDeleteAddress(address: any) {
        this.messageService.startLoading("Excluindo endereço...");
        let body = {
            cpf: this.modelLocator.dadosLogin.cpf,
            id: address.id,
            status: address.status
        }

        await this.userAddressService.deleteUserAddress(body).then((data: any) => {
            console.log("🚀 ~ MmUserAddressComponent ~ this.userAddressService.deleteUserAddress ~ data:", data);
            if (data['status'] == 200) {
                this.getListOfAddres();
            }
            this.messageService.endLoading();
        }).catch(error => {
            console.log("🚀 ~ MmUserAddressComponent ~ touchDeleteAddress ~ error:", error);
            this.messageService.endLoading();
            this.messageService.showToast(error['error'].message, 'warning', 'bottom', 5000, true);
        })
    }

    /**
     * Touchs edit address
     * @author Starley Cazorla
     * @param address
     */
    touchEditAddress(address: any) {
        this.formAddress = address;
        this.editAddress = true;
    }

    touchConfirm() {
        this.toEventDismiss.emit(this.formAddress);
    }
}
